import { AxiosResponse } from 'axios';

import { api } from '../../providers/base-api';
import { PermissionAlias } from '../../utils/enums';

export async function getPermissionsByUserRequest(): Promise<
  AxiosResponse<PermissionAlias[]>
> {
  const response = await api.get<PermissionAlias[]>(`team-permissions`);

  return response;
}

export async function getUserPermissionsRequest(): Promise<
  AxiosResponse<PermissionAlias[]>
> {
  const response = await api.get<PermissionAlias[]>(`user-permissions`);

  return response;
}

export async function getUserPermissionsByIdRequest(
  userId: number,
): Promise<AxiosResponse<PermissionAlias[]>> {
  const response = await api.get<PermissionAlias[]>(
    `user-permissions/${userId}`,
  );

  return response;
}

export async function setUserPermissionsRequest(
  userId: number,
  permissions: PermissionAlias[],
): Promise<AxiosResponse<void>> {
  const response = await api.put<void>(`user-permissions/${userId}`, {
    permissions,
  });

  return response;
}
